import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';


@Component({
    selector: 'app-layout',
    templateUrl: '../templates/template1/views/app-layout.component.html',
    styleUrls: ['../templates/template1/themes/default/less/app-layout.component.less',
    '../templates/template1/themes/default/less/rtl.less'
    ],
    encapsulation: ViewEncapsulation.None
})
export class AppLayoutComponent implements OnInit {
    accessDeviceInfo: any;
    isPromotionContent: string;

    constructor(private _router: Router, private _commonService:CommonService) {
        this._router.events.subscribe((event) => {
            this.isPromotionContent = this._commonService.isEventsPage(window.location.pathname);
        });
    }
    ngOnInit() {
    }

    // @HostListener('window:resize', ['$event'])
    // onResize(event: any) {
    //     this.getDeviceSpecification();
    // }
}
